import React from 'react';

import { createStyles, WithStyles, withStyles, withWidth } from '@material-ui/core';
import MuiDialog, { DialogProps as MuiDialogProps } from '@material-ui/core/Dialog';
import { Breakpoint } from '@material-ui/core/styles/createBreakpoints';
import classnames from 'classnames';

const styles = () =>
  createStyles({
    root: {},
  });

export interface DialogProps extends Omit<MuiDialogProps, 'classes'>, WithStyles<typeof styles> {
  preventSubmit?: boolean;
  width?: Breakpoint;
}

const Dialog: React.FC<DialogProps> = ({ classes, className, width, preventSubmit, ...rest }) => (
  <MuiDialog
    onKeyDown={(e) => {
      // Prevent dialogs from submitting forms on higher components
      if (preventSubmit && e.key === 'Enter') {
        e.preventDefault();
      }
    }}
    className={classnames(classes.root, className)}
    fullScreen={width === 'xs'}
    {...rest}
  />
);

export default withWidth()(withStyles(styles, { name: 'LumaDialog' })(Dialog));
